import _ from 'lodash';
import { lsFilters } from 'ls-vue-common';
import moment from 'moment';

//eslint-disable-next-line import/prefer-default-export
export const generateRecommendationContent = ({ recommendation }) => {
  if (_.isNil(recommendation)) {
    return null;
  }
  const contractorFirstName = _.get(recommendation, 'contractor.user.first_name', '');
  const headerMain = `${contractorFirstName} sent you a quote `;

  const priceMain = lsFilters.currency({ amount: recommendation.price });
  const endStatus = `${lsFilters.date({
    date: recommendation.expires_at,
  })}`;
  const hoursNeeded = recommendation.hours_needed;
  const serviceName = `${lsFilters.titleCase({ text: recommendation.service.name })}`;
  const serviceId = recommendation.service.service_id;
  const scheduledStart = `${lsFilters.date({
    date: recommendation.schedule_at,
  })}`;
  const startStatus = `on ${lsFilters.date({
    date: recommendation.created_at,
  })}`;
  const scheduledEnd = `${lsFilters.date({
    date: moment(recommendation.schedule_at).add(1, 'days'),
  })}`;

  const statusSetDate = `${lsFilters.date({
    date: recommendation.status_set_at,
  })}`;

  return {
    contractorFirstName,
    headerMain,
    startStatus,
    priceMain,
    endStatus,
    hoursNeeded,
    serviceName,
    serviceId,
    scheduledStart,
    scheduledEnd,
    statusSetDate,
  };
};
